import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './LandingPage';
import NotionAuth from './NotionAuth';
import { ClerkProvider, useUser } from '@clerk/clerk-react';
import NotionAuthRedirect from './NotionRedirect';
import RegistrationPage from './RegistrationPage';
import PageSelect from './PageSelect';
import StripeCancelPage from './StripeCancelPage';
import ProfileInfo from './ProfileInfo';
import StripeSuccessPage from './StripeSuccessPage';
import SignInPage from './SignInPage';

// const PUBLIC_PUBLISHABLE_KEY = "pk_test_dXAtdGVybWl0ZS01Mi5jbGVyay5hY2NvdW50cy5kZXYk";
const PUBLISHABLE_KEY = "pk_live_Y2xlcmsubm90ZXRpbWVsaW5lcy5jb20k";
// I like this but I feel like there has to be a way to abstract some of these conditional routes
if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

function App() {
  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <MainApp />
    </ClerkProvider>
  );
}

function MainApp() {
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      console.log("User Information:", user);
    } else {
      console.log("No user is logged in.");
    }
  }, [user]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/parked" element={<LandingPage />} />
        <Route path="/cancel" element={<StripeCancelPage />} />
        {!user && <Route path="/login" element={<RegistrationPage />} />}
        {user && <Route path="/login" element={<NotionAuth />} />}
        <Route path="/register" element={<NotionAuth />} />
        <Route path="/redirect" element={<NotionAuthRedirect />} />
        <Route path="/page-select" element={<PageSelect />} />
        <Route path="/profile-info" element={<ProfileInfo />} />
        <Route path="/success" element={<StripeSuccessPage />}/>
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/login/sso-callback" element={<SignInPage />} />
        <Route path="/error" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
